export default "__VITE_ASSET__hQrjNdAG__"